import { useContext } from 'react';
import { PageContext, PageContextType } from '#page/contexts';

const usePageContext = () => useContext<PageContextType>(PageContext);

export { usePageContext };
